import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
const socialProofData = [{
  name: 'Marek W.',
  city: 'Warszawa',
  time: '3 min temu'
}, {
  name: 'Tomasz K.',
  city: 'Kraków',
  time: '5 min temu'
}, {
  name: 'Rafał B.',
  city: 'Poznań',
  time: '7 min temu'
}, {
  name: 'Piotr S.',
  city: 'Gdańsk',
  time: '12 min temu'
}, {
  name: 'Krzysztof M.',
  city: 'Wrocław',
  time: '15 min temu'
}, {
  name: 'Jakub L.',
  city: 'Łódź',
  time: '18 min temu'
}, {
  name: 'Michał P.',
  city: 'Lublin',
  time: '22 min temu'
}, {
  name: 'Łukasz C.',
  city: 'Katowice',
  time: '25 min temu'
}, {
  name: 'Adam N.',
  city: 'Szczecin',
  time: '28 min temu'
}, {
  name: 'Paweł F.',
  city: 'Bydgoszcz',
  time: '31 min temu'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const t = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(t);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    const t = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(t);
  }, [visible, dismissed]);
  useEffect(() => {
    if (dismissed || visible) return;
    const t = setTimeout(() => {
      setCurrentIndex(p => (p + 1) % socialProofData.length);
      setVisible(true);
    }, 8000);
    return () => clearTimeout(t);
  }, [visible, dismissed]);
  if (dismissed) return null;
  const person = socialProofData[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-50 max-w-sm transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0 pointer-events-none'}`} data-id="element-297">
      <div className="bg-brand-navy border-l-4 border-brand-green rounded-xl p-4 pr-10 shadow-xl relative" data-id="element-298">
        <button onClick={() => setDismissed(true)} className="absolute top-3 right-3 text-slate-400 hover:text-white transition-colors" aria-label="Zamknij" data-id="element-299">
          <X className="w-4 h-4" data-id="element-300" />
        </button>
        <div className="flex items-start gap-3" data-id="element-301">
          <div className="w-10 h-10 rounded-full bg-brand-green/20 flex items-center justify-center shrink-0" data-id="element-302">
            <span className="text-brand-green text-lg" data-id="element-303">⚽</span>
          </div>
          <div className="flex-1 min-w-0" data-id="element-304">
            <p className="text-sm text-slate-200" data-id="element-305">
              <span className="font-bold text-white" data-id="element-306">{person.name}</span>{' '}
              <span className="text-slate-400" data-id="element-307">z {person.city}</span>{' '}
              <span className="text-slate-400" data-id="element-308">🇵🇱</span>
            </p>
            <p className="text-sm text-slate-300 mt-1" data-id="element-309">
              Właśnie kupił{' '}
              <span className="text-brand-green font-bold" data-id="element-310">
                Futbol Gotowy: System 365
              </span>
            </p>
            <p className="text-xs text-slate-400 mt-2 flex items-center gap-1.5" data-id="element-311">
              <span className="w-2 h-2 rounded-full bg-brand-green inline-block animate-pulse" data-id="element-312" />
              ZAKUP ZWERYFIKOWANY · {person.time}
            </p>
          </div>
        </div>
      </div>
    </div>;
}